import { Flex, HStack, Icon, Square, Text } from '@chakra-ui/react';

import AssignmentBuilderPreviewStatus from '../data-display/AssignmentBuilderPreviewStatus';
import { DefaultTFuncReturn } from 'i18next';
import { ElementType } from 'react';
import { LockFilled } from '@/client/components/icons/ContinuIcons';

interface AssignmentFormPreviewHeaderProps {
  formName: 'automations' | 'audience' | 'content' | 'settings' | 'notifications';
  icon: ElementType;
  title: DefaultTFuncReturn | string;
  renderStatus?: boolean;
  isLocked?: boolean;
}

export default function AssignmentFormPreviewHeader({
  formName,
  icon,
  title,
  renderStatus = false,
  isLocked = false,
}: AssignmentFormPreviewHeaderProps) {
  return (
    <Flex padding={6} justifyContent="space-between">
      <HStack spacing={2}>
        <Square
          size="24px"
          backgroundColor="neutral.0"
          border="1px solid"
          borderColor="neutral.100"
          borderRadius="4.8px"
        >
          <Icon as={icon} color="neutral.1100" />
        </Square>

        <Text fontSize="16px" fontWeight={600} color="baseBlack">
          {title}
        </Text>

        {isLocked && <LockFilled boxSize={4} />}
      </HStack>

      {renderStatus && <AssignmentBuilderPreviewStatus form={formName} />}
    </Flex>
  );
}
